import React from 'react';

const Briefcase: React.FC = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.668 5.00008H14.168V3.33341C14.168 2.41425 13.4205 1.66675 12.5013 1.66675H7.5013C6.58214 1.66675 5.83464 2.41425 5.83464 3.33341V5.00008H3.33464C2.41547 5.00008 1.66797 5.74758 1.66797 6.66675V15.8334C1.66797 16.7526 2.41547 17.5001 3.33464 17.5001H16.668C17.5871 17.5001 18.3346 16.7526 18.3346 15.8334V6.66675C18.3346 5.74758 17.5871 5.00008 16.668 5.00008ZM12.5013 3.33341V5.00008H7.5013V3.33341H12.5013ZM6.66797 6.66675H16.668V9.16675H3.33464V6.66675H6.66797ZM3.33464 15.8334V10.8334H8.33464V12.5001H11.668V10.8334H16.668L16.6688 15.8334H3.33464Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Briefcase;
